// custom-global.js only for global scripts
// Use different js files for different pages/sections to improve performance

// ==================== Start utility functions ====================
const setCookie = function(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = function(cname) {
  let name = cname + "=";
  let  decodedCookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch (e) {
    decodedCookie = document.cookie; 
  }
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
// ==================== End utility functions ====================

// ==================== Start Mobile Menu ====================
const mobileMenuBtn = document.querySelector('.header__mobile-menu-btn');
const mobileMenuBtnOpen = document.querySelector('.mobile-menu-btn__open');
const mobileMenuBtnClose = document.querySelector('.mobile-menu-btn__close');
const mobileMenu = document.querySelector('.header__mobile-menu');
const mobileMenuHeaderBtns = document.querySelectorAll('div.mobile-menu__header-btn');
const mobileMenuChildLinks = document.querySelectorAll('.top-links__child-links');
const mobileMenuChildLinkContainers = document.querySelectorAll('.top-links__child-link-container');

// ~~~~~~~~~~ Start Helper functions ~~~~~~~~~~
const openAndCloseMobileMenu = () => {
  mobileMenuBtnOpen.classList.toggle('hidden');
  mobileMenuBtnClose.classList.toggle('hidden');
  mobileMenu.classList.toggle('opened');
  document.body.classList.toggle('mobile-menu-opened');
}

const closeMobileMenu = () => {
  mobileMenuBtnOpen.classList.remove('hidden');
  mobileMenuBtnClose.classList.add('hidden');
  mobileMenu.classList.remove('opened');
  document.body.classList.remove('mobile-menu-opened');
}
// ~~~~~~~~~~ End Helper functions ~~~~~~~~~~

// Open & Close Mobile Menu
mobileMenuBtn.addEventListener('click', () => {
  // Close search box
  closeSearchBox();
  clearSearchSuggestions();

  // Open & Close Mobile Menu
  openAndCloseMobileMenu();
})

// Header Buttons
mobileMenuHeaderBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    const relatedChildLinks = document.querySelector(btn.getAttribute('data-class'));

    if (btn.classList.contains('active')) return;

    // Active class
    mobileMenuHeaderBtns.forEach(el => el.classList.remove('active'));
    btn.classList.add('active');

    // Related Child Links active
    mobileMenuChildLinks.forEach(el => el.classList.remove('active'));
    relatedChildLinks.classList.add('active');
  })
})

// Child Link containers
mobileMenuChildLinkContainers.forEach(container => {
  const relatedChildLink = container.querySelector('.top-links__child-link');

  relatedChildLink.addEventListener('click', () => {
    const grandchildContainers = document.querySelectorAll('.top-links__grandchild-container');
    const relatedGrandchildContainer = container.querySelector('.top-links__grandchild-container');
    const relatedGrandchildHight = getComputedStyle(relatedGrandchildContainer.querySelector('.top-links__grandchild-links')).height;

    if (container.classList.contains('active')) {
      // Remove active class
      container.classList.remove('active');
      // Close Related Grandchild Container
      relatedGrandchildContainer.style.maxHeight = 0;
    } else {
      // Add active class
      mobileMenuChildLinkContainers.forEach(el => el.classList.remove('active'));
      container.classList.add('active');
      // Open Related Grandchild Links
      grandchildContainers.forEach(el => el.style.maxHeight = 0);
      relatedGrandchildContainer.style.maxHeight = relatedGrandchildHight;
    }
  })
})

// Resize
window.addEventListener('resize', () => {if (window.innerWidth > 990) closeMobileMenu()});
// ==================== End Mobile Menu ====================

// ==================== Start Header Search ====================
// ===== Variables =====
const searchBox = document.querySelector('.search__search-box');
const searchBoxForm = searchBox.querySelector('.search-box__form');
const searchBoxInput = searchBox.querySelector('.search-box__input');
const searchBoxIconSearch = searchBox.querySelector('.search-box__icon-search');
const searchBoxIconClear = searchBox.querySelector('.search-box__icon-clear');
const smallScreenIconSearch = document.querySelectorAll('.search__small-screen-icon--search');
const smallScreenIconClose = document.querySelectorAll('.search__small-screen-icon--close');

const searchSuggestions = document.querySelector('.search-suggestions');
const resultsCollections = document.querySelector('.results__collections');
const resultsCollectionsContent = resultsCollections.querySelector('.results__content');
const resultsProducts = document.querySelector('.results__products');
const resultsProductsContent = resultsProducts.querySelector('.results__content');
const resultsNoFound = document.querySelector('.results__no-found');
const searchSuggestionsViewAll = searchSuggestions.querySelector('.search-suggestions__view-all');
const searchOverlay = document.querySelector('.search-overlay');
const headerDesktopMenu = document.querySelector('.header__desktop-menu');

let searchTimer;

// ===== Start Helper Functions =====
const submitSearchForm = function() {
  if (searchBoxInput.value.length > 0) document.querySelector('.search-box__form').submit();
}

const openSearchBox = function() {
  // Check if the mobile menu is opened
  if (mobileMenu.classList.contains('opened')) {closeMobileMenu()};

  smallScreenIconSearch.forEach(el => el.classList.add('hidden'));
  smallScreenIconClose.forEach(el => el.classList.remove('hidden'));
  searchBox.classList.add('small-screen-open');
  searchBoxInput.focus();
  searchOverlay.classList.add('small-screen-open');
  document.body.classList.add('search-opened');
}

const closeSearchBox = function() {
  smallScreenIconClose.forEach(el => el.classList.add('hidden'));
  smallScreenIconSearch.forEach(el => el.classList.remove('hidden'));
  searchBox.classList.remove('small-screen-open');
  searchOverlay.classList.remove('small-screen-open');
  document.body.classList.remove('search-opened');
}

const clearSearchBoxInput = function() {
  searchBoxInput.value = '';
  searchBoxIconClear.classList.add('hidden');
}

const clearSearchSuggestions = function() {
  searchSuggestions.classList.add('hidden');
  resultsCollections.classList.add('hidden');
  resultsCollectionsContent.innerHTML = '';
  resultsProducts.classList.add('hidden');
  resultsProductsContent.innerHTML = '';
  resultsNoFound.innerHTML = '';
  resultsNoFound.classList.add('hidden');
  searchSuggestionsViewAll.classList.add('hidden');
  searchOverlay.classList.remove('large-screen-open');
}

// ==================== Start Debounce Function ====================
function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer); 
    timer = setTimeout(() => {
      func(...args); 
    }, delay);
  };
}
// ==================== End Debounce Function ====================

// ==================== Start Search Suggestion ====================
const sendSearchToGA = (rawTerm) => {
  const EXCLUDED_WORDS = ['bra','polo','tank','sale'];
  const MIN_LENGTH     = 5;

  const term = rawTerm.trim().toLowerCase();                 

  if (term.length < MIN_LENGTH || EXCLUDED_WORDS.some(w => term.includes(w))) return;

  const sentTerms = JSON.parse(sessionStorage.getItem('sentSearchTerms') || '[]');

  if (sentTerms.includes(term)) return;                     

  gtag('event', 'search_results', { search_term: term });
  sentTerms.push(term);
  sessionStorage.setItem('sentSearchTerms', JSON.stringify(sentTerms));
};


const searchSuggestios = function() {
  let searchTimeout;

  // Get Predictive Search API
  fetch(`/search/suggest.json?q=${searchBoxInput.value}&resources[type]=product,collection`)
    .then(response => response.json())
    .then(suggestions => {
      const suggestedCollections = suggestions.resources.results.collections;
      const suggestedProducts = suggestions.resources.results.products;

      // 1- Clear Search Suggestions
      clearSearchSuggestions();

      // 2- Show Search Suggestions
      searchSuggestions.classList.remove('hidden');
      searchOverlay.classList.add('large-screen-open');

      if (suggestedProducts.length < 1 && suggestedCollections.length < 1) {
        resultsNoFound.classList.remove('hidden');
        resultsNoFound.innerHTML = `<p>Sorry, nothing found for "<b>${searchBoxInput.value}</b>".</p>`;
      }

      // 3- Show Results
      if (suggestedCollections.length > 0) {
        resultsCollections.classList.remove('hidden');
        suggestedCollections.forEach(collection => {
          const collectionHTML = `
            <p class="results__content--link" data-href="${collection.url}">
              <a href="${collection.url}">${collection.title}</a>
            </p>`;
          resultsCollectionsContent.insertAdjacentHTML("beforeend", collectionHTML);
        });
      }

      if (suggestedProducts.length > 0) {
        resultsProducts.classList.remove('hidden');
        suggestedProducts.forEach(product => {
          const imgURL = product.featured_image.url;
          const imgURLFirst = imgURL.slice(0, imgURL.lastIndexOf('.'));
          const imgURLLast = imgURL.slice(imgURL.lastIndexOf('.'));
          const imgRatio = `_240x240`;
          const imgURLOptimized = `${imgURLFirst}${imgRatio}${imgURLLast}`;
          const comparePrice = parseFloat(product.compare_at_price_max) > 0 ?
          `${searchBoxInput.getAttribute('data-currency')}${parseFloat(product.compare_at_price_max)}` : '';
          const productCardHTML = `
            <div class="search-product-card">
              <a href="${product.url}">
                <div class="search-product-card__image">
                  <div class="image-container">
                    <img class="image-cover" src="${imgURLOptimized}" alt="${product.featured_image.alt}" loading="lazy">
                  </div>
                </div>
                <div class="search-product-card__info">
                  <p class="search-product-card__title">${product.title}</p>
                  <p class="search-product-card__price">
                    ${searchBoxInput.getAttribute('data-currency')}${parseFloat(product.price)}
                    <span class="search-product-card__compare-price">${comparePrice}</span>
                  </p>
                </div>
              </a>
            </div>`;

          resultsProductsContent.insertAdjacentHTML("beforeend", productCardHTML);
          searchSuggestionsViewAll.classList.remove('hidden');
        });
      }

      // Set up real-time search term tracking
      clearTimeout(searchTimeout);
      const delay = window.innerWidth <= 768 ? 2000 : 1000; 
     
      searchTimeout = setTimeout(() => {
        sendSearchToGA(searchBoxInput.value); // Send search term to GA after delay
      }, delay);
    });
};
// ==================== End Search Suggestion ====================

// ==================== Start Main Functions ====================
// Debounce the search input event handler
const debouncedSearch = debounce(searchSuggestios, 500); // 500ms delay

// Attach the debounced function to the input event
searchBoxInput.addEventListener('input', function () {
  if (searchBoxInput.value) {
    debouncedSearch(); // Call the debounced search function
  } else {
    clearSearchSuggestions(); // Clear suggestions if no input
  }
});


// ===== Start Main Functions =====
// Submit Search Form
searchBoxIconSearch.addEventListener('click', submitSearchForm);
searchSuggestionsViewAll.addEventListener('click', submitSearchForm);

// Open/Close search box on smaller screens
smallScreenIconSearch.forEach(el => el.addEventListener('click', openSearchBox));
smallScreenIconClose.forEach(el => {
  el.addEventListener('click', () => {
    closeSearchBox();
    clearSearchSuggestions();
  })
})

// on Input Change
searchBoxInput.addEventListener('input', function() {
  // 1- Show/Hide Clear Text Icon
  if (searchBoxInput.value) {
    searchBoxIconClear.classList.remove('hidden');
  } else {
    searchBoxIconClear.classList.add('hidden');
  }

  // 2- Search suggestions - Predictive Search API
  clearTimeout(searchTimer);
  if (searchBoxInput.value) {
    searchTimer = setTimeout(searchSuggestios, 300);
  } else {
    clearSearchSuggestions();
  }
})

// on Input Focus
searchBoxInput.addEventListener('focus', function() {
  if (searchSuggestions.classList.contains('hidden')) {
    if (searchBoxInput.value) {
      searchSuggestios();
    } 
  }
})

// Clear Text
searchBoxIconClear.addEventListener('click', function() {
  clearSearchBoxInput();
  clearSearchSuggestions();
})

// Close Search Suggestions
// 1- Esc key
window.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    if (window.innerWidth > 1399) {
      clearSearchSuggestions();
    } else {
      closeSearchBox();
      clearSearchSuggestions();
    }
  }
});
// 2- Overlay click
searchOverlay.addEventListener('click', function() {
  if (window.innerWidth > 1399) {
    clearSearchSuggestions();
  } else {
    closeSearchBox();
    clearSearchSuggestions();
  }
});
// 3- Desktop Menu hover
headerDesktopMenu.addEventListener('mouseenter', function() {
  if (window.innerWidth > 1399) {
    clearSearchSuggestions();
  } else {
    closeSearchBox();
    clearSearchSuggestions();
  }
});
// ===== End Main Functions =====
// ==================== End Header Search ====================

// ==================== Start Product Card ====================
const optmizeImageURL = function(url) {
  const imgURL = url;
  const imgURLFirst = imgURL.slice(0, imgURL.lastIndexOf('.'));
  const imgURLLast = imgURL.slice(imgURL.lastIndexOf('.'));
  const imgRatio = `_500x500`;
  const imgURLOptimized = `${imgURLFirst}${imgRatio}${imgURLLast}`;

  return imgURLOptimized;
}

// ==================== 1) Color Update ====================
const productCardColorUpdateFunction = function() {
  const colorSwatches = document.querySelectorAll('.product-card .color-swatch');

  colorSwatches.forEach(swatch => {
    const thisProductCard = swatch.closest('.product-card');
    const swatchColor = swatch.getAttribute('data-color');
    const productHandle = thisProductCard.getAttribute('data-product-handle');
    const url = `/products/${productHandle}.js`;
    const thisCardImageContainer = thisProductCard.querySelector('.product-card__image .image-container');
    const variantColorEl = thisProductCard.querySelector('.product-card__variant-color');
    const productCardLinks = thisProductCard.querySelectorAll('.product-card__link');
    let productColors;
  
    swatch.addEventListener('click', function() {
      if (swatch.classList.contains('active')) return;

      fetch(url)
      .then(response => response.json())
      .then(data => {

        for (let i = 0; i < data.variants.length; i++) {
          if (data.variants[i].option1 === swatchColor && data.variants[i].featured_image.src) {
            // 1- Swatch Active Class
            thisProductCard.querySelectorAll('.color-swatch').forEach(el => el.classList.remove('active'));
            swatch.classList.add('active');
  
            // 2- Update the Variant Color Element
            variantColorEl.textContent = '';
            variantColorEl.textContent = swatchColor;

            // 3- Update card Link
            const currentVariantID = data.variants[i].id;
            productCardLinks.forEach(link => {
              const linkURL = link.getAttribute('href');
              const linkURLFirst = linkURL.slice(0, linkURL.lastIndexOf('='));
              
              link.setAttribute('href', `${linkURLFirst}=${currentVariantID}`);
            })

            // 4- Update Featured Image
            // First image
            const imgURL = data.variants[i].featured_image.src;
            const imgURLFirst = imgURL.slice(0, imgURL.lastIndexOf('.'));
            const imgURLLast = imgURL.slice(imgURL.lastIndexOf('.'));
            const imageHTML = 
            `
            <img 
              src="${imgURLFirst}_800x${imgURLLast}"
              alt="${swatchColor}"
              srcset="${imgURLFirst}_180x${imgURLLast} 180w,
                      ${imgURLFirst}_360x${imgURLLast} 360w,
                      ${imgURLFirst}_540x${imgURLLast} 540w,
                      ${imgURLFirst}_720x${imgURLLast} 720w,
                      ${imgURLFirst}_800x${imgURLLast} 800w"
              class="image-cover"
              sizes="(min-width: 1700px) 395px,(min-width: 990px) calc((100vw - 120px) / 4), (min-width: 750px) calc((100vw - 80px) / 2), calc(100vw / 2)">
            `
            thisCardImageContainer.innerHTML = imageHTML;

            // Slider
            data.media.forEach(media => {
              if (media.media_type === 'image' 
                && media.alt === data.variants[i].option1 
                && media.id !== data.variants[i].featured_media.id) {
                const imgURL = media.src;
                const imgURLFirst = imgURL.slice(0, imgURL.lastIndexOf('.'));
                const imgURLLast = imgURL.slice(imgURL.lastIndexOf('.'));
                const imageHTML = 
                `
                <img 
                  src="${imgURLFirst}_800x${imgURLLast}"
                  alt="${swatchColor}"
                  srcset="${imgURLFirst}_180x${imgURLLast} 180w,
                          ${imgURLFirst}_360x${imgURLLast} 360w,
                          ${imgURLFirst}_540x${imgURLLast} 540w,
                          ${imgURLFirst}_720x${imgURLLast} 720w,
                          ${imgURLFirst}_800x${imgURLLast} 800w"
                  class="image-cover hide-hover"
                  sizes="(min-width: 1700px) 395px,(min-width: 990px) calc((100vw - 120px) / 4), (min-width: 750px) calc((100vw - 80px) / 2), calc(100vw / 2)">
                `
                thisCardImageContainer.insertAdjacentHTML("beforeend", imageHTML);
                thisCardImageContainer.scrollLeft = 0; 
              }
            })
            break;
          }
        }
  
        // 5- Update Hover Image
        data.options.forEach(option => {if (option.name === 'Color') productColors = option.values});
        if (!productColors) return;
        
        productColors.forEach(color => {
          if (color === swatchColor) {
            // Array of current color images
            let currentColorImages = [];
            data.media.forEach(media => {if (color === media.alt) currentColorImages.push(media)});

            if (currentColorImages.length <= 1) return;
    
            // Get the last Image to set as hover image
            const lastImage = currentColorImages[currentColorImages.length - 1];
            if (!lastImage) return;
            
            const imgURL = lastImage.src;
            const imgURLFirst = imgURL.slice(0, imgURL.lastIndexOf('.'));
            const imgURLLast = imgURL.slice(imgURL.lastIndexOf('.'));
            const imageHTML = 
            `
            <img 
              src="${imgURLFirst}_800x${imgURLLast}"
              alt="${swatchColor}"
              srcset="${imgURLFirst}_180x${imgURLLast} 180w,
                      ${imgURLFirst}_360x${imgURLLast} 360w,
                      ${imgURLFirst}_540x${imgURLLast} 540w,
                      ${imgURLFirst}_720x${imgURLLast} 720w,
                      ${imgURLFirst}_800x${imgURLLast} 800w"
              class="image-cover product-card__image--hover"
              sizes="(min-width: 1700px) 395px, (min-width: 990px) calc((100vw - 120px) / 4), (min-width: 750px) calc((100vw - 80px) / 2), calc(100vw / 2)">
            `
            thisCardImageContainer.insertAdjacentHTML("beforeend", imageHTML);
          }
        })
      })

      // Update product card price if in collection
      if (window.location.href.indexOf("collections") != -1) {
        const url = `${window.location.pathname}?section_id=${thisProductCard.dataset.sectionId}&filter.v.option.color=${swatchColor}`;

        fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newProductCard = html.querySelector(`.product-card[data-product-handle=${productHandle}]`);
          const oldPriceDesktop = thisProductCard.querySelector('.product-card__price');
          const newPriceDesktop = newProductCard.querySelector('.product-card__price');
          const oldPriceMobile = thisProductCard.querySelector('.product-card__price--mobile');
          const newPriceMobile = newProductCard.querySelector('.product-card__price--mobile');

          if (oldPriceDesktop && newPriceDesktop) oldPriceDesktop.innerHTML = newPriceDesktop.innerHTML;
          if (oldPriceMobile && newPriceMobile) oldPriceMobile.innerHTML = newPriceMobile.innerHTML;
        })
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', productCardColorUpdateFunction);

// ==================== 2) Color swatches scroll on mobile ====================
const productCardColorSwatchesScroll = function() {
  if (window.innerWidth <= 750) {
    const productCards = document.querySelectorAll('.product-card');
  
    productCards.forEach(card => {
      const colorSwatches = card.querySelector('.product-card__color-swatches');
      if (!colorSwatches) return;
      const colorSwatchesWidth = parseInt(getComputedStyle(colorSwatches).width);
      const colorSwatchesArrowLeft = card.querySelector('.product-card__color-swatches-arrow--left');
      const colorSwatchesArrowRight = card.querySelector('.product-card__color-swatches-arrow--right');
      if (!colorSwatchesArrowLeft) return;
      if (!colorSwatchesArrowRight) return;
      const colorSwatchesChildren = colorSwatches.querySelectorAll('.color-swatch');
      let oneSwatchWidth = 0;
      let colorSwatchesChildrenWidth = 0;
      
      // Calc children color swatches width
      colorSwatchesChildren.forEach(swatch => {
        const swatchWidth = parseInt(getComputedStyle(swatch).width) + parseInt(getComputedStyle(swatch).marginRight);
        oneSwatchWidth = swatchWidth;
        colorSwatchesChildrenWidth += swatchWidth;
      })
  
      // Show right arrow if children width more than parent width
      if (colorSwatchesChildrenWidth > colorSwatchesWidth) {
        // Check if not scrolled to the end
        if (Math.abs(colorSwatches.scrollLeft) !== colorSwatches.scrollWidth - colorSwatches.clientWidth) {
          colorSwatchesArrowRight.style.display = 'block';
        }
      } else {
        colorSwatchesArrowRight.style.display = 'none';
        colorSwatchesArrowLeft.style.display = 'none';
      }
  
      // If scroll to the end, hide right arrow and show left arrow
      colorSwatches.addEventListener('scroll', () => {
        if (Math.abs(colorSwatches.scrollLeft) === colorSwatches.scrollWidth - colorSwatches.clientWidth) {
          colorSwatchesArrowRight.style.display = 'none';
          colorSwatchesArrowLeft.style.display = 'block';
        } else {
          colorSwatchesArrowRight.style.display = 'block';
          colorSwatchesArrowLeft.style.display = 'none';
        }
      })
  
      // Scroll 3 colors when right arrow is clicked
      colorSwatchesArrowRight.addEventListener('click', () => {
        const threeSwatchesWidth = oneSwatchWidth * 3;
  
        colorSwatches.scrollTo({
          left: colorSwatches.scrollLeft + threeSwatchesWidth,
          behavior: 'smooth'
        });
      })
  
      // Scroll to the first color when left arrow is clicked
      colorSwatchesArrowLeft.addEventListener('click', () => {
        colorSwatches.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      })
    })
  }
}

document.addEventListener('DOMContentLoaded', productCardColorSwatchesScroll);
window.addEventListener('resize', productCardColorSwatchesScroll);

// ==================== 3) Swipe hint ====================
const productCardSwipeHint = function() {
  const firstProductCard = document.querySelector('.main-collection .product-card:first-child') 
    || document.querySelector('.main-search .product-card:first-child')
    || document.querySelector('.preorder-products .product-card:first-child');
  firstProductCard?.classList.add('swipe-hint');
  setTimeout(() => {
    firstProductCard?.classList.remove('swipe-hint');
  }, 1500);
}

window.addEventListener('load', () => {
  setTimeout(productCardSwipeHint, 2000);
});
// ==================== End Product Card ====================


// ==================== Start Unisex Collections ====================
// Gender Filters
const unisexCollectionSwitchGender = document.querySelectorAll('.unisex-collection__switch--gender');

unisexCollectionSwitchGender.forEach(el => {
  el.addEventListener('click', function() {
    /* If ie. Men is clicked, toggle all Unisex swatches to Men and vice versa*/
    document
      .querySelectorAll(`.unisex-collection__switch--gender[data-gender="${this.dataset.gender}"]`)
      .forEach(btn => {
        if (btn !== this) btn.click();
      });

    if (el.classList.contains('active')) return;

    const getGender = this.dataset.gender;
    const unisexCollectionSlider = this.closest('.unisex-collection').querySelector('.unisex-collection__switch--slider');
    const firstGenderCollection = this.closest('.unisex-collection').querySelector('.unisex-collection__first');
    const secondGenderCollection = this.closest('.unisex-collection').querySelector('.unisex-collection__second');
    const currentCollectionURL = this.dataset.url;
    const viewAllBtn = this.closest('.unisex-collection').querySelector('.unisex-collection__button a');
    
    // 1. Remove active class
    el.closest('.unisex-collection__switch').querySelectorAll('.unisex-collection__switch--gender').forEach(btn => btn.classList.remove('active'));

    // 2. Add active class
    this.classList.add('active');

    // 3. Update slider & collection
    if (getGender == 'first') {
      // Update Slider
      unisexCollectionSlider.classList.remove('active-second');
      unisexCollectionSlider.classList.add('active-first');

      // Update Collection
      firstGenderCollection.classList.add('active');
      secondGenderCollection.classList.remove('active');

    } else if (getGender == 'second') {
      // Update Slider
      unisexCollectionSlider.classList.remove('active-first');
      unisexCollectionSlider.classList.add('active-second');

      // Update Collection
      secondGenderCollection.classList.add('active');
      firstGenderCollection.classList.remove('active');

    }

    // 4. Update view all button
    viewAllBtn.setAttribute('href', currentCollectionURL);
  })
})


// Slider
// Prevent click event when dragging
var drag = false;

// Allow more than one slider at the same time
document.querySelectorAll('.unisex-collection__slider').forEach(slider => { 
  new KeenSlider(slider, {
    dragChecked() {
      drag = true;
    },
    dragEnded() {
      setTimeout(() => (drag = false), 0);
    },
    created() {
      document.querySelectorAll('.unisex-collection__slider').forEach(slider => {
        slider.addEventListener("click", (e) => {
          if (drag) {
            e.stopPropagation();
            e.preventDefault();
          }
        })
      });
    },
    breakpoints: {
      '(max-width: 449px)': {
        slides: {
          perView: 1.35,
          spacing: 16
        }
      },
      '(min-width: 450px)': {
        slides: {
          perView: 2.5,
          spacing: 20
        }
      },
      '(min-width: 990px)': {
        disabled: true,
      },
    },
  }, [navigation])
})
// ==================== Start Unisex Collections ====================

// ==================== Start Lazyload Videos ====================
const videoObserverFunctionality = function() {

  const videos = document.querySelectorAll('.video-lazy-selector');

  const lazyLoadingVideos = function(entries) {
    entries.forEach(video => {
      if (video.isIntersecting) {
        // Swap src
        for (var source in video.target.children) {
          var videoSource = video.target.children[source];
          if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.setAttribute('src', videoSource.getAttribute('data-video-src'));
          }
        }
        video.target.load();

        // Stop observing
        videoObserver.unobserve(video.target);
      };
    });
  };
  const videoObserver = new IntersectionObserver(lazyLoadingVideos, {
    root: null, // viewport
    threshold: 0,
    rootMargin: '200px' // Start early 200px
  });
  videos.forEach(vid => videoObserver.observe(vid));
}

window.addEventListener('load', videoObserverFunctionality);
// ==================== End Lazyload Videos ====================

// ==================== Start Footer ====================
const footerMenuHeaders = document.querySelectorAll('.footer__menu--heading');

footerMenuHeaders.forEach(header => {
  header.addEventListener('click', function() {
    const thisSubmenu = this.closest('.footer__menu--col').querySelector('.footer__menu--sublinks-container');

    // 1- Animate caret icon
    this.querySelector('.footer__menu--caret').classList.toggle('open');

    // 2- Show/Hide submenu
    thisSubmenu.classList.toggle('small-hide');
    thisSubmenu.classList.toggle('medium-hide');
  })
})
// ==================== End Footer ====================

// ==================== Start Personalize homepage for women ====================
const visitedPage = function() {
  if (window.location.pathname.includes('women') || window.location.pathname.includes('woman')) {
    setCookie('personalize', 'women', 30);
  } else if (window.location.pathname.includes('products/') || window.location.pathname.includes('collections/')) {
    setCookie('personalize', 'men', 30); 
  } else if (getCookie('personalize') === 'women' || (new URLSearchParams(window.location.search).get('load') === 'women')) {
    personalizeHomepageForWomen();
  } else if (getCookie('personalize') === 'men' || (new URLSearchParams(window.location.search).get('load') === 'men')) {
    personalizeHomepageForMen();
  } else {
    personalizeHomepageDefault();
  }
  document.querySelector('.hero-banner')?.classList.remove('loading');
}

const personalizeHomepageDefault = function () {
  if (window.location.pathname === '/') {
    // load default content 
    document.querySelector('.hero-banner')?.classList.remove('loading');
  }

}
const personalizeHomepageForWomen = function () {
  // for all pages - show women menu on mobile 
  document.querySelector('.mobile-menu__header-btn')?.click();


  // homepage customization
  if (window.location.pathname === '/') {
    // change url to women
    history.replaceState(null, '', window.location.pathname + '?load=women');

    // Update gender switch to women
    document.querySelectorAll('[class*="switch--gender"]').forEach(el => {
      if (el.dataset.gender === 'second' || el.dataset.gender === 'women') {
        el.click();
      }
    })

    //show women CTAs
    let hero_banner_btns_women = document.querySelector('.hero-banner__btns--women');
    if (hero_banner_btns_women) {
      hero_banner_btns_women.classList.remove('hidden');
      document.querySelector('.hero-banner__btns--both')?.classList.add('hidden');
    }
    document.querySelector('.hero-banner')?.classList.remove('loading');
  }
}

const personalizeHomepageForMen = function () {
  if (window.location.pathname === '/') {
    // change url to men
    history.replaceState(null, '', window.location.pathname + '?load=men');
    //show men CTAs
    let hero_banner_btns_men = document.querySelector('.hero-banner__btns--men');
    if (hero_banner_btns_men) {
      hero_banner_btns_men.classList.remove('hidden');
      document.querySelector('.hero-banner__btns--both')?.classList.add('hidden');
    }

    document.querySelector('.hero-banner')?.classList.remove('loading');
  }
}

document.addEventListener('DOMContentLoaded', visitedPage);
// ==================== End Personalize homepage for women ====================

// ==================== Start Shopify money format ====================
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
  cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) {
          return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
      case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
      case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
  }
  return formatString.replace(placeholderRegex, value);
};

function getCurrencySymbol(currencyCode) {
  const symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: 'C$',
    AUD: 'A$',
    CHF: 'CHF ',
    HUF: 'FT',
    FT: 'FT',
  };
  return symbols[currencyCode] || '';
}
// ==================== End Shopify money format ====================


// ==================== Start New/Returning visitor cookie ====================
document.addEventListener("DOMContentLoaded", function() {
  const isHomepage = document.querySelector('body').classList.contains('index');
  const isProduct = document.querySelector('body').className.includes('product');
  // check how many different days the user visited the website
  const today = new Date().toISOString().split('T')[0]; 
  const lastVisitDate = localStorage.getItem('lastVisitDate');
  let visitCount = parseInt(localStorage.getItem('siteVisitCount')) || 0;

  if (lastVisitDate !== today) { // New day = count as a new visit
    visitCount += 1;
    localStorage.setItem('siteVisitCount', visitCount);
    localStorage.setItem('lastVisitDate', today);
  }

  if (isHomepage) { // change the order of the LatestArrivals and bestSellers for returning visitors
      const isReturningToHomepage = localStorage.getItem("returning_visitor");
      const bestSellersSections = Array.from(document.querySelectorAll('h3.unisex-collection__title'))
      .filter(h3 => h3.textContent.trim().includes('Best Sellers'))
      .map(h3 => h3.closest('.shopify-section'));
      const LatestArrivalsSections = Array.from(document.querySelectorAll('h3.unisex-collection__title'))
      .filter(h3 => h3.textContent.trim().includes('Latest arrivals'))
      .map(h3 => h3.closest('.shopify-section'));

      if (LatestArrivalsSections.length >= 2 && bestSellersSections.length >= 2) {
        if (isReturningToHomepage) {
          // Returning visitor
          // keep the first latest Arrivals, hide the second
          LatestArrivalsSections[1]?.classList.add('hidden');
          // keep the second best sellers, hide the first
          bestSellersSections[0]?.classList.add('hidden');
        
        } else {
          // New visitor
          localStorage.setItem("returning_visitor", "true");
          // keep the second latest Arrivals, hide the first
          LatestArrivalsSections[0]?.classList.add('hidden');
          // keep the first best sellers, hide the second
          bestSellersSections[1]?.classList.add('hidden');

        }
      }
  }else if (isProduct) { // hide UGC videos for returning visitors
    if (visitCount > 2) { 
       const ugcVideos = document.querySelector('.ugc-videos');
        if (ugcVideos) {
          ugcVideos.style.display = 'none';
        }
    }
  }

});


// ==================== End New/Returning visitor cookie ====================
// ==================== Start helper copy text ====================
function copyToClipboard(textToCopy) {
  console.log("___________________________test")
  navigator.clipboard.writeText(textToCopy);

  const tooltip = document.createElement("span");
  tooltip.className = "tooltiptext";
  tooltip.innerHTML = "Copied: " + textToCopy;
  document.querySelector("#MainContent").appendChild(tooltip);

  // Hide again after 2 seconds
  setTimeout(function() {
    tooltip.classList.add("hidden");
    tooltip.innerHTML = "";
    tooltip.remove();
  }, 2000);
}

// ==================== End helper copy text ====================


// ==================== Start affiliates-announcement-message ====================
document.addEventListener("DOMContentLoaded", function() {
  let affiliate_announcement = getCookie('affiliate_announcement');
  const announcement_bar = document.querySelector("#announcement__slider")

  if (announcement_bar && affiliate_announcement !== '') {
      // clear the current announcement bar conetnt
      let parsedDoc = new DOMParser().parseFromString(affiliate_announcement, "text/html");
      let affiliate_announcement_node = parsedDoc.body.firstChild;
      
      announcement_bar.insertBefore( affiliate_announcement_node,  announcement_bar.children[1] || null );
      announcement_bar.querySelector('.textToCopy').addEventListener('click', function (e) {
        let textToCopy = e.target.innerText;
        copyToClipboard(textToCopy);
      });
      window?.announcementSlider.update(); 
  }
});


// ==================== End affiliates-announcement-message ====================
